// extracted by mini-css-extract-plugin
var _1 = "Uploader-module__dropPlaceholder--G2zbd";
export { _1 as "dropPlaceholder" }
